'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var utils = require('@chakra-ui/utils');
var button = require('./button.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'list', 'listItem', 'item', 'ellipsis', 'arrow'];
var baseStyleContainer = {
  // Lobotomized owl selector
  // Used in `<Stack />` as well.
  '& > *:not(style)~*:not(style)': {
    ml: 1
  },
  mb: -1,
  listStyle: 'none',
  display: 'flex'
};
var baseStyleList = {
  // Lobotomized owl selector
  // Used in `<Stack />` as well.
  '& > *:not(style)~*:not(style)': {
    ml: 1
  },
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center'
};
var baseStyleListItem = {
  display: 'flex',
  mb: 1
};
var baseStyleItem = function baseStyleItem(props) {
  var c = props.colorScheme,
    theme = props.theme;
  var buttonBaseStyle = button["default"].baseStyle(props);
  var buttonVariantSecondary = button["default"].variants.inverted({
    colorScheme: 'gray',
    theme: theme
  });
  var buttonVariantSolid = button["default"].variants.solid({
    colorScheme: c,
    theme: theme
  });

  // The spreading here is a bit excessive, but it's the only way to make it work
  // with an uncontrolled (button) and controlled (a) component.
  return _objectSpread(_objectSpread(_objectSpread({
    display: 'flex'
  }, buttonBaseStyle), buttonVariantSecondary), {}, {
    _disabled: _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle._disabled), buttonVariantSecondary._disabled), {}, {
      _focus: _objectSpread({}, buttonVariantSecondary._disabled)
    }),
    _activeStep: utils.mergeWith(buttonVariantSolid, {
      _hover: {
        color: 'white'
      },
      _disabled: {
        _focus: {
          color: 'white'
        }
      }
    })
  });
};
var baseStyleEllipsis = {
  cursor: 'default',
  color: 'gray.400'
};
var baseStyleArrow = function baseStyleArrow(props) {
  var c = props.colorScheme,
    theme = props.theme;
  var buttonBaseStyle = button["default"].baseStyle(props);
  var buttonVariantGhost = button["default"].variants.ghost({
    colorScheme: c,
    theme: theme
  });
  return _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle), buttonVariantGhost), {}, {
    _disabled: _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle._disabled), buttonVariantGhost._disabled), {}, {
      // This disables links as well. The reason for this is so when you're at
      // the first or last page and want to go previous or next respectively,
      // it will not do anything, as the `arrow` is disabled if that's the case.
      pointerEvents: 'none'
    }),
    mb: 1
  });
};
var baseStyle = function baseStyle(props) {
  return {
    container: baseStyleContainer,
    list: baseStyleList,
    listItem: baseStyleListItem,
    item: baseStyleItem(props),
    arrow: baseStyleArrow(props),
    ellipsis: baseStyleEllipsis
  };
};
var sizes = {
  sm: {
    item: button["default"].sizes.sm,
    arrow: button["default"].sizes.sm,
    ellipsis: button["default"].sizes.sm
  },
  md: {
    item: button["default"].sizes.md,
    arrow: button["default"].sizes.md,
    ellipsis: button["default"].sizes.md
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Pagination = {
  parts: parts,
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = Pagination;